import pc from './src/components/pc';
export default pc;
